<template>
<div>
    <ul class="reports_list" v-if="newsList.length > 0">
        <li v-for="(item,index) in newsList" :key="index">
            <Row>
                <Col span="20" class="rpt_cnt">
                    <span class="rpt_time">{{item.publish_time | timeTrans}}</span>
                    <span class="rpt_title"><a target="_blank" :href="item.src_url | page">{{item.title}}</a></span>
                </Col>
                <Col span="4" class="rpt_src_name">{{item.src_name | empty}}</Col>
            </Row>
        </li>
    </ul>
    <Nothing v-else><p>暂无相关报道</p></Nothing>
</div>
</template>

<script>
import Nothing from '@/components/Nothing.vue'
export default {
  name: 'AboutNews',
  props: ['newsList'],
  components: {
    Nothing
  }
}
</script>

<style lang="stylus" scoped>
.no_news
  padding: 30px
  commonBgColor(#1f2330, #FFFFFF)
  commonColor(rgba(255,255,255,.5), #999999)
  text-align: center
.reports_list
  padding: 20px 50px
  commonBgColor(#1f2330, #FFFFFF)
  border-top: 0
  li
    font-size: 14px
    line-height: 1
    .rpt_cnt
      display: flex
      .rpt_time
        padding: 10px 20px 10px 0
        commonColor(rgba(255,255,255,.5), #999999)
        flex: 0 0 96px
        margin-right: 20px
        position: relative
        border-right: 1px solid
        commonBorderColor(#353945, #E8E8E8)
        &:before
          content: ''
          position: absolute
          width: 8px
          height: 8px
          commonBgColor(#353945, #E8E8E8)
          border-radius: 50%
          top: 17px
          right: -8px
          transform: translate(-50%,-50%)
      .rpt_title
        padding: 5px 0
        line-height: 24px
        color: #333
        flex: auto
        a
          commonColor(rgba(255,255,255,.9), #333333)
          &:hover
            color: rgba(250, 122, 80, 1)
    .rpt_src_name
      padding: 10px 0
      color: #999
      text-align: right
</style>
